<template>
  <div id="widget-download">
   <PopUp :options="options" />
  </div>
</template>
<script>
import PopUp from './PopUp.vue'
export default {
  name: 'App',
  props: {
    options: { default: null },
  },
  components: {
    PopUp
  },
}
</script>
